import { HttpClient } from '@angular/common/http';
import { ITranslationResource, MultiTranslateHttpLoaderV2, ShellDomainProvider } from '@ecap3/core';
import { DeltaMobileAppCentralizedTranslationLoader } from './delta-mobile-app-centralized-translation-loader';



export class DeltaTranslationResourceModel {
	prefix = '';
	suffix = '';

	constructor(prefix: string) {
		if (!ShellDomainProvider['api']) {
			console.error('ShellDomainProvider.api is not initialized');
			this.prefix = ''; 
			return;
		}

		const isLoadTranslationsCentrally = ShellDomainProvider['api'].loadTranslationsCentrally;
		const centralizedAppModuleName = 'generic-app';

		if (isLoadTranslationsCentrally && !prefix) {
			this.prefix = `${ShellDomainProvider['api'].BlocksUilmService}GetUilmFile?ModuleName=${centralizedAppModuleName}&ProjectKey=${ShellDomainProvider['api'].UilmXBlocksKey}&Language=`;
		} else {
			this.prefix = `${ShellDomainProvider['api'].BlocksUilmService}GetUilmFile?ModuleName=${prefix}&ProjectKey=${ShellDomainProvider['api'].UilmXBlocksKey}&Language=`;
		}
	}
}

export function genericHttpLoaderFactory(apps: string[]) {
	return (http: HttpClient) => {
		const translationResources: ITranslationResource[] = [];

		apps = ['generic-app', 'notification']; //NOSONAR
		for (const app of apps) {
			const instance = new DeltaTranslationResourceModel(app);
			translationResources.push(instance);
		}
		return new DeltaMobileAppCentralizedTranslationLoader(http, translationResources);
	};
}